define('BookingEngine/app-BookingEngine/main',['./settings', "util", '../app-Departures/main', '../../app-Loader/main', 'jquery-ui', 'sumoselect'], function (settings, util, departures, loader) {
    console.log('app-bookingengine');
    return {        
        run: function () {
            var summary = $(settings.container);

            if (summary.length === 0) {
                window.log('Filter module will not be available.');
                return;
            }

            window.log('Loading Filter Module');

            //Convert port description with the dictionary.
            $('.depSelectedDepPoint').each(function () {
                var code = $(this).text().trim();
                $(this).find('.sortval').html(PortDescriptionDictionary[code]);
            });

            $('.doPodDesc').each(function () {
                var code = $(this).text().trim();
                $(this).html(PortDescriptionDictionary[code]);
            });

            //Convert the board basis using the dictionary.
            $('.depSelectedBoard').each(function () {
                var code = $(this).text().trim();
                $(this).find('.sortval').html(BbDescriptionDictionary[code]);
            });

            //Setting each button to make its call, set the current module to summary and the next module to active.
            $(".beFilterOptions").on('click', '.filtersSearchBtn', function () {
                //update the ADL and make the direct call
                AdlAddUpdateItem('pageName', 'travel|purchase|checkout|departures');
                util.satelliteTrack('virtualPageViewTBJ');

                //Get the current selected filter values when the button is pressed.
                var sdmVal = $('#filterdepartureMonth').val();
                var sdm = (sdmVal === '') ? 'any' : sdmVal;
                var sdmtVal = $('#filterdepartureMontht').val();
                var sdmt = (sdmtVal === '') ? 'any' : sdmtVal;
                var sdVal = $('#filterduration').val();
                var sd = (sdVal === '') ? 'any' : sdVal;
                var sbbVal = $('#filterboardBasis').val();
                var sbbValStr = (sbbVal === null) ? '' : sbbVal.toString(); // to string - change multi values to comma seperated (with null check)
                var sbb = (sbbValStr === '' || sbbValStr === 'MB') ? 'any' : sbbVal;
                var sdfVal = $('#filterdepartingFrom').val();
                var sdf = (sdfVal === '') ? 'any' : sdfVal;
                var sgVal = $('#filterguests').val();
                var sg = (sgVal === '') ? 'any' : sgVal;
                var saVal = $('#filtercarrier').val();
                var saValStr = (saVal === null) ? '' : saVal.toString(); // to string - change multi values to comma seperated (with null check)
                var sa = (saValStr === '') ? 'any' : saValStr;
                var soVal = $("#filteroccupancy").val();
                var so = (soVal === '') ? 'any' : soVal;

                //Populate these values to the selectedFiltersModel.  
                var filtersSelectedModel = {
                    "NoOfPassengers": sg,
                    "DepartureStartMonth": sdm,
                    "DepartureEndMonth": sdmt,
                    "Duration": sd,
                    "BoardBasis": sbb,
                    "DepartingFrom": sdf,
                    "CarrierPreference": sa,
                    "Occupancy": so
                }

                //POST SELECTED Filters > GET FLAG.
                $.ajax({
                    url: '/filtersmodule/select',
                    type: 'POST',
                    data: JSON.stringify(filtersSelectedModel),
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    success: function (data) {
                        if (data.success) {
                            $('.filtersSummary').show();
                            $('#forcedFilterMessage, .filtersActive').hide();
                            $('#depModuleActive').show();
                            $('#depModuleSummary, #depModuleDisabled').fadeOut('slow');
                            $("html, body").animate({ scrollTop: $("#depModuleActive").offset().top - 15 }, 'slow', 'swing');
                            departures.ActivateDepartures();
                        }
                    },
                    error: function () {
                        console.log("There was an error with the filters module: " + data.errorDetails);
                    }
                });
            });

            var disabledModule = $(settings.disabledModule);
            var summaryModule = $(settings.summaryModule);
            var activeModule = $(settings.activeModule);

            //Filter change on click.
            $(".filtersChangeBtn").on("click", function () {
                $('.makeSumoSelect').SumoSelect();
                $('.filtersActive').slideDown("slow");
                $('.filtersSummary').slideUp('slow');
                $("html, body").animate({ scrollTop: $(".filtersActive").offset().top - 15 }, 'slow', 'swing');

                //make direct call to ADL
                util.satelliteTrack('travelCriteriaChange');

                //If the departures is in summary then make sure summary is shown when the filters button is pressed.
                if (summaryModule.is(':visible')) {
                    //Change warning on filters if user changes option.
                    $('#changeWarning').fadeIn('slow');

                    $('.cancelFilterChange').on('click', function () {
                        $('.filtersSummary').slideDown();
                        $('.filtersActive').slideUp();
                    });

                    disabledModule.fadeOut("slow", function () {
                        summaryModule.fadeIn('slow');
                        activeModule.fadeOut('slow');
                    });
                } else {
                    disabledModule.fadeIn("slow", function () {
                        summaryModule.slideUp('slow');
                        activeModule.slideUp('slow');
                    });
                }
            });

            window.loadedModules("BookingEngine/app-BookingEngine");
        }
    };
});
